export default "/img/WS.a81ddfc98724af7d7f1587bf04ca179c.png";